export default __webpack_public_path__ + "static/media/mobileFaderImage3.4ce780aa.png";